const bibNumber = (number, numberDigits = 4) => {
  numberDigits = numberDigits || 4
  const pad = [...Array(numberDigits + 1)].join('0')
  return pad.substr(0, pad.length - `${number}`.length) + number
}

export default bibNumber



// WEBPACK FOOTER //
// ./src/App/utils/bibNumber.js